import { FeatureExplanationBlock } from '@models/feature-explanation';

export type FeatureId = string;

export interface Feature {
  id: FeatureId;
  explanation: {
    tokens: FeatureExplanationBlock[];
  };
  explanation_str: string;
  user_explanation?: string;
}

export namespace FeatureId {
  /**
   *
   * @param id string e.g. fd_123  fd_123_456
   *  fd_123 is a base ID, _456 is a suffix of copied feature
   */
  export function getOriginId(id: string): FeatureId {
    return `fd_${id.split('_')[1]}`;
  }
}
